import { querySelector } from './querySelectors';

const SENT_CLASS = 'is-sent';
const SENT_TIMEOUT = 5000;
const SUCCESS_CLASS = 'w-form__success';

export default function(form) {
  let data = {};

  try {
    data = JSON.parse(event.detail.response);
  }
  catch (error) {
    data = {};
  }

  if (data.error) {
    window.alert(data.error);
  }
  else if (data.success) {
    let success = querySelector(`.${SUCCESS_CLASS} p`, form);

    if (success) {
      success.innerHTML = data.success;
    }

    form.classList.add(SENT_CLASS);

    setTimeout(() => {
      form.classList.remove(SENT_CLASS);
    }, SENT_TIMEOUT);
  }
  else if (data.redirect) {
    window.location.href = data.redirect;
  }
}
